var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
export var mosAppHostedAtRootRouteGuard = function (props) {
    var e_1, _a;
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t;
    var canActivate = !!((_c = (_b = props.featureGates) === null || _b === void 0 ? void 0 : _b.mosAppHostedAtRootGates) === null || _c === void 0 ? void 0 : _c.mosAppHostedAtRootEnabled);
    // MosAppHostedAtRoot route supports multiple paths.
    // Check each path and only return paths user has access to.
    var shouldUpdatePath = false;
    var supportedPaths = [];
    if (canActivate && props.path && typeof props.path !== 'string') {
        try {
            for (var _u = __values(props.path), _v = _u.next(); !_v.done; _v = _u.next()) {
                var path = _v.value;
                if (path.indexOf('/chat') >= 0) {
                    // TODO: this license check logic if copied from shouldInstall() in fetchPreinstalledApps.ts. Consider moving it to a shared place
                    var isInternalAllowlistedUser = (_e = (_d = props.featureGates) === null || _d === void 0 ? void 0 : _d.immersiveBizchatM365AppGates) === null || _e === void 0 ? void 0 : _e.immersiveBizchatM365AppEnabled;
                    var isLicensedUser = ((_g = (_f = props.featureGates) === null || _f === void 0 ? void 0 : _f.immersiveBizchatM365AppGates) === null || _g === void 0 ? void 0 : _g.immersiveBizchatM365AppEnabledWithLicense) &&
                        ((_h = props.userEntitlements) === null || _h === void 0 ? void 0 : _h.HasCopilotBusinessChat);
                    var isExternalLicensedUser = ((_k = (_j = props.featureGates) === null || _j === void 0 ? void 0 : _j.immersiveBizchatM365AppGates) === null || _k === void 0 ? void 0 : _k.immersiveBizchatM365AppMochaEnabled) &&
                        ((_l = props.userEntitlements) === null || _l === void 0 ? void 0 : _l.HasCopilotBusinessChat);
                    var isModeB = ((_o = (_m = props.featureSettings) === null || _m === void 0 ? void 0 : _m.copilot) === null || _o === void 0 ? void 0 : _o.mode) === 'ModeB';
                    (isInternalAllowlistedUser ||
                        isLicensedUser ||
                        isExternalLicensedUser ||
                        isModeB) &&
                        supportedPaths.push(path);
                }
                else if (path.indexOf('/onedrive') >= 0) {
                    var isOneDriveMosAppEnabled = (_q = (_p = props.featureGates) === null || _p === void 0 ? void 0 : _p.oneDriveMosAppGates) === null || _q === void 0 ? void 0 : _q.oneDriveMosAppEnabled;
                    var isLicensedUser = (_r = props.userEntitlements) === null || _r === void 0 ? void 0 : _r.HasOneDrive;
                    isOneDriveMosAppEnabled &&
                        isLicensedUser &&
                        supportedPaths.push(path);
                }
                else if (path.indexOf('/testapp') >= 0) {
                    var isTestAppEnabled = !!((_t = (_s = props.featureGates) === null || _s === void 0 ? void 0 : _s.m365TestAppGates) === null || _t === void 0 ? void 0 : _t.m365TestAppEnabled);
                    isTestAppEnabled && supportedPaths.push(path);
                }
                else {
                    supportedPaths.push(path);
                }
                shouldUpdatePath = props.path.length !== supportedPaths.length;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_v && !_v.done && (_a = _u.return)) _a.call(_u);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    return {
        canActivate: canActivate,
        shouldUpdatePath: shouldUpdatePath,
        updatedPath: shouldUpdatePath ? supportedPaths : undefined,
    };
};
//# sourceMappingURL=mosAppHostedAtRootRouteGuard.js.map